import { render, staticRenderFns } from "./HideChats.vue?vue&type=template&id=3b4d29cb&scoped=true&"
import script from "./HideChats.vue?vue&type=script&lang=js&"
export * from "./HideChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d29cb",
  null
  
)

export default component.exports